module.exports = __webpack_public_path__ + "static/media/comercial.36c8cbe3.svg";